<template>
    <div id="content" class="audit" :class="[{ detail: addeditId, 'template-list': !detailId && !addeditId }, $mq]">
        <div v-if="!detailId && Object.values(templates).length >= 4" class="audit-templates-search-bar">
            <SearchBar :search="search" @on-search="searchBarInput" @on-button-click="cleanSearch" :placeholder="$t('login.search.placeholder_audits')" customClass="search-bar-audit" />
        </div>

        <div v-if="!addeditId" class="content scrollbar full" :class="[{ 'hide-scrollbar': ['portrait'].includes($mq), 'detail-audit': detailId }]">
            <!-- Search Bar - Solo mostrar cuando hay 4 o más templates -->
            <div v-if="showTemplatesLoader" class="audit-templates-loader">
                <div class="loader"></div>
            </div>

            <template v-else>
                <item v-if="!detailId" v-for="reg in filteredTemplates" :key="reg.id" :item="reg" :auditsnoPhoto="auditsNoPhoto" @sendedId="openDetail" @sendedAddedit="createAudit"></item>
                <EmptyPage v-if="!detailId && getHasTemplatesApiError && Object.values(templates).length == 0" :type="'error'" :title="$t('empty_pages.api_error_title')" :description="$t('empty_pages.api_error_description')"></EmptyPage>
                <EmptyPage v-else-if="!detailId && Object.values(filteredTemplates).length == 0 && search" :title="$t('empty_pages.no_results_title')" :description="$t('empty_pages.no_results_description')"></EmptyPage>
                <EmptyPage v-else-if="!detailId && Object.values(templates).length == 0 && !getHasTemplatesApiError" :title="$t('empty_pages.generic_title')" :description="$t('empty_pages.audit_template_description')"></EmptyPage>
            </template>

            <resume :hasError="errorAudit()" v-if="detailId && audit && !addeditId" :audits="audit" :detailId="detailId" @sendedAddedit="loadAuditEdit"></resume>

            <p v-if="detailId && audit && !addeditId && !audit" class="empty">
                {{ $t('audit.empty_templates') }}
            </p>
        </div>

        <detail v-if="detailId && addeditId" :cType="checkType" :gId="addeditId" :showErrors="showErrors" @update-show-errors="updateShowErrors" :openSection="openSection" @updateToggle="updateToggle" @reopened="onAuditReopened"></detail>
    </div>
</template>

<script>
import { FORMAT } from '@/constants'
import EmptyPage from '@/components/layout/EmptyPage'
import item from '@/components/domain/audit/item'
// Este detail es la tabla
import resume from '@/components/domain/audit/resume'
// Este detail es el comun de cheklist para crear
import detail from '@/components/domain/audit/detail'
import i18n from '@/i18n'
import SearchBar from '@/components/domain/ui/SearchBar'

export default {
    name: 'Audit',
    components: { item, resume, detail, EmptyPage, SearchBar },
    data() {
        return {
            checkType: 2,
            detail: false,
            addedit: false,
            FORMAT: FORMAT,
            auditsNoPhoto: true,
            showErrors: false,
            openSection: null,
            search: ''
        }
    },
    computed: {
        locationHasActionPlansTool() {
            return this.$store.getters['login/getLocationHasActionPlansTool']
        },
        getHasTemplatesApiError() {
            return this.$store.getters['audit/getHasTemplatesApiError']
        },
        templatesLoading() {
            return this.$store.getters['audit/getTemplatesLoading']
        },
        templatesLoaded() {
            return this.$store.getters['audit/getTemplatesLoaded']
        },
        showTemplatesLoader() {
            const templatesAreEmpty = Object.values(this.templates).length == 0
            return !this.detailId && !this.search && templatesAreEmpty && !this.getHasTemplatesApiError && (this.templatesLoading || !this.templatesLoaded)
        },
        user_id() {
            return this.$store.getters['loginUser/getLocalEmployee']
        },
        user() {
            var employee = this.$store.getters['employee/getEmployee'](this.user_id)
            if (employee) {
                return employee
            }
        },
        templates() {
            var templates = this.$store.getters['audit/getTemplates']

            var result = {}

            // Validar que el usuario existe antes de acceder a sus propiedades
            if (!this.user || !this.user.rol) {
                return result // Retornar objeto vacío si no hay usuario
            }

            var rolEmployee = this.$store.getters['employee/getRol'](this.user.rol)

            // Validar que el rol del empleado existe
            if (!rolEmployee) {
                return result
            }

            for (var templates_index in templates) {
                var template = templates[templates_index]
                if (template && template.config != false && template.config.nRoles && template.config.nRoles.length > 0) {
                    const templateRoles = template.config.nRoles
                    let bAuditAdded = false
                    templateRoles.forEach((role) => {
                        if (role.roleId == this.user.rol) {
                            result[templates_index] = template
                            bAuditAdded = true
                        }
                    })

                    if (rolEmployee.level >= 8 && !bAuditAdded) {
                        result[templates_index] = template
                    }
                } else if (template && template.config != false && template.config.roles && template.config.roles.length > 0) {
                    // Si el rol del usuario está en el listado del template o es nivel 8 se muestra
                    var templateroles = template.config.roles

                    if (templateroles.includes(this.user.rol) || rolEmployee.level == 8) {
                        result[templates_index] = template
                    }
                    // SI NO TIENE NINGUN ROL SE MUESTRA
                } else result[templates_index] = template
            }

            // DETECT IF ANY ITEM HAS A PHOTO
            var self = this
            var imageFound = Object.values(result).filter((obj) => {
                return obj.image != false ? (self.auditsNoPhoto = false) : true
            })

            return result
        },
        filteredTemplates() {
            if (!this.search) {
                return this.templates
            }

            const searchLower = this.search.toLowerCase()
            const result = {}

            for (const key in this.templates) {
                const template = this.templates[key]
                if (template && template.name && template.name.toLowerCase().includes(searchLower)) {
                    result[key] = template
                }
            }

            return result
        },
        audit() {
            const audit = this.$store.getters['audit/getItems']
            const sortedReturn = Object.keys(audit)
                .sort((a, b) => moment(audit[b].created_date) - moment(audit[a].created_date))
                .reduce((obj, key) => {
                    obj[key] = audit[key]
                    return obj
                }, {})
            return sortedReturn
        },
        detailId: {
            get() {
                return this.detail
            },
            set(value) {
                this.detail = value
            }
        },
        addeditId: {
            get() {
                return this.addedit
            },
            set(value) {
                this.addedit = value
            }
        },

        // obtener score para mostrar el popup
        check() {
            var check = this.$store.getters['audit/getById'](this.$route.params.edit)
            return check
        },
        // saber si mostrar el popup o no
        template() {
            var template = this.$store.getters['audit/getTemplateById'](this.$route.params.id)
            // var showScore = { show_score: 0 }
            // templates.config = showScore

            return template
        },
        userAppAccess() {
            return this.$store.getters['loginUser/getHasAccessApp']
        },
        itemsExcluded() {
            return this.$store.getters['tasks/getItemsExcluded']
        },
        roles() {
            return this.$store.getters['employee/getAllRoles']
        },
        auditsWithTempId() {
            return this.$store.getters['audit/getItemsWithTemporalId']
        }
    },
    methods: {
        searchBarInput(e) {
            this.search = e.target.value
        },
        cleanSearch() {
            this.search = ''
        },
        updateShowErrors(newShowErrorsValue) {
            this.showErrors = newShowErrorsValue
        },
        updateToggle(newOpenSectionValue) {
            this.openSection = newOpenSectionValue
        },
        rolesWithWritePermissions() {
            const permissions = this.templates[this.$route.params.id]
            const roles = []
            if (permissions && permissions.config && permissions.config.nRoles && permissions.config.nRoles.length > 0) {
                const idOfRoles = permissions.config.nRoles.map((role) => {
                    if (role.permissions.includes('w')) {
                        return role.roleId
                    }
                })
                Object.values(this.roles).map((role) => {
                    if (idOfRoles.includes(role.id)) {
                        roles.push(role.name)
                    }
                })
            }

            return roles
                .join(', ')
                .toString()
                .replace(/,(?=[^,]*$)/, ' ' + this.$t('answer.or'))
        },
        errorAudit() {
            if (this.templates.length == 0 || this.detailId == undefined) {
                return false
            }
            for (var template in this.templates) {
                var idx = this.templates[template]
                if (idx.id == this.detailId) {
                    return false
                }
            }
            return true
        },
        load(refresh = true) {
            var self = this

            // if (this.templates && Object.values(this.templates).length > 0 && this.userAppAccess) {
            //     this.$bar.addAction('create', {
            //         callback: function () {
            //             self.listAudits()
            //         },
            //         label: self.$t('popup.add_template.text_save')
            //     })
            // }

            self.detailId = self.$route.params.id
            //   self.addeditId = self.$route.params.edit

            if (self.detailId && !self.$route.params.edit) {
                self.showErrors = false
                self.openSection = null
                self.addeditId = false

                self.$overlay.loading()

                self.$store
                    .dispatch('audit/loadItems', { template: self.detailId, noRefresh: self.$route.params.noRefresh })
                    .then(function () {
                        self.openDetail(self.detailId)
                        self.$overlay.hide()
                    })
                    .catch((error) => {
                        console.error('Error in audit/loadItems:', error)
                        self.$overlay.hide()
                    })

                if (this.locationHasActionPlansTool) {
                    self.$store.dispatch('actionplan/loadActionPlansData', { auditTemplateId: self.detailId }).catch(function (error) {
                        console.error('Error with dispatch actionplan/loadActionPlansData:', error)
                    })
                }
            } else if (self.detailId && self.$route.params.edit) {
                self.$overlay.loading()
                self.$store
                    .dispatch('audit/loadById', { id: self.$route.params.edit, noRefresh: self.$route.params.noRefresh })
                    .then(function () {
                        self.addeditId = self.$route.params.edit
                        self.openAddedit(self.addeditId)
                        self.$overlay.hide()
                    })
                    .catch((error) => {
                        logError('Error in audit/loadById:', error)
                        self.$overlay.hide()
                    })
            } else {
                self.addeditId = false
            }
        },

        currentEmployee() {
            var emp_id = this.$store.getters['loginUser/getLocalEmployee']

            if (emp_id) {
                var emp = this.$store.getters['employee/getEmployee'](emp_id)
            } else {
                var emp = this.$store.getters['loginUser/getLocalLocation']
            }

            return emp
        },

        openDetail(id) {
            var self = this

            if (self.$store.getters['hasAccess'](self.currentEmployee().id, 0)) {
                self.goToDetail(id)
            } else {
                this.$popup.login({
                    list: this.$store.getters['employee/getLoginUsers'](1),
                    callAfterAccess: function (response) {
                        if (response) {
                            self.goToDetail(id)
                            self.$popup.close()
                        }
                    }
                })
            }
        },
        goToDetail(id) {
            var self = this

            if (!self.detailId) {
                self.$router.push({ name: 'AuditDetail', params: { id: id } })
            } else {
                self.$bar.reset()

                // self.$bar.addAction('back', {
                //     callback: function() {
                //         self.$router.push({ name: 'Audit' })
                //     },
                //     label: self.$t('menu_aux.action.back')
                // })
                // validate if template has roles
                var template = this.templates[this.$route.params.id]
                var templateroles = template && template.config && template.config.roles && template.config.roles.length > 0 ? template.config.roles : false
                let userRoleHasTemplateRole = templateroles && this.user && this.user.rol ? templateroles.includes(this.user.rol) : true
                // if (this.templates && Object.values(this.templates).length > 0 && Object.values(this.audit).length > 0 && this.userAppAccess && userRoleHasTemplateRole) {
                //     self.$bar.addAction('create', {
                //         callback: function () {
                //             self.createAudit(id)
                //         },
                //         label: self.$t('menu_aux.action.create')
                //     })
                // }
            }
        },
        createAudit(id) {
            var self = this
            if (!fnCheckConnection() && !this.$store.getters['getOffline']) {
                self.$popup.alert({
                    closable: false,
                    blocking: false,
                    message: self.$t('popup.audit.offline_add'),
                    textSave: self.$t('popup.audits.exit'),
                    callSave: function (response) {
                        self.$popup.close()
                    }
                })
                return
            }

            self.$overlay.loading()
            self.$store.dispatch('audit/loadItems', { template: id }).then(function () {
                var audit_tmpl = self.$store.getters['audit/getTemplateById'](id)
                var roles = typeof audit_tmpl.config.roles !== 'undefined' && audit_tmpl.config.roles != '' ? audit_tmpl.config.roles.toString() : []
                var level = typeof audit_tmpl.config.level !== 'undefined' ? audit_tmpl.config.level : 2

                var empl_curr = self.$store.getters['loginUser/getLocalEmployee']
                empl_curr = self.$store.getters['employee/getEmployee'](empl_curr)
                const roleLevel = self.$store.getters['employee/getRol'](empl_curr.rol).level
                if ((self.checkPermissions(id, true) && (roles.length == 0 || roles.includes(empl_curr.rol))) || roleLevel >= level) {
                    // if (self.$store.getters['hasAccess'](self.currentEmployee().id, role)) {
                    // self.$router.push({
                    //   name: 'AuditEdit',
                    //   params: { id: id, edit: 'add' }
                    // })
                    self.$store.dispatch('audit/changeSupervisor', { emp_id: self.currentEmployee().id })
                    self.$popup.close()

                    self.$store
                        .dispatch('audit/add', {
                            tpl_id: id,
                            cType: audit_tmpl.type,
                            emp_ref: self.currentEmployee().id
                        })
                        .then(function (response) {
                            self.addeditId = response.id

                            self.$router.push({
                                name: 'AuditEdit',
                                params: { id: id, edit: self.addeditId }
                            })
                            self.$overlay.hide()
                        })
                } else {
                    self.$overlay.hide()
                    self.$popup.alert({
                        closable: false,
                        blocking: false,
                        message: self.$t('popup.audits.not_level_permission'),
                        textSave: self.$t('popup.audits.exit'),
                        callSave: function (response) { }
                    })
                }
            })
        },

        checkPermissions(id, isTemplateParam = false) {
            // Validar que el usuario existe
            if (!this.user || !this.user.rol) {
                return false
            }

            const template = isTemplateParam ? this.$store.getters['audit/getTemplateById'](id) : this.$store.getters['audit/getById'](id)
            const userRole = this.$store.getters['employee/getRol'](this.user.rol)

            // Validar que el rol existe
            if (!userRole) {
                return false
            }

            if (userRole.level >= 8) {
                return true
            }

            // Si el objeto config no existe o no tiene nRoles/roles, permitir edición (comportamiento por defecto)
            if (!template || !template.config || (!template.config.nRoles && !template.config.roles)) {
                return true
            }

            // Si existe config.nRoles, verificar permisos según roles
            if (template.config.nRoles && template.config.nRoles.length > 0) {
                return template.config.nRoles.some((role) => {
                    return role.roleId == userRole.id && role.permissions && role.permissions.includes('w')
                })
            }

            // Si existe config.roles (formato antiguo), mantener compatibilidad
            if (template.config.roles && template.config.roles.length > 0) {
                // Si el usuario tiene nivel 8 o superior, tiene todos los permisos
                if (userRole.level >= 8) {
                    return true
                }
                return template.config.roles.includes(this.user.rol)
            }

            return false
        },

        checkManagePermission(config) {
            if (!this.user || !this.user.rol) {
                return false
            }

            const userRole = this.$store.getters['employee/getRol'](this.user.rol)
            if (!userRole) {
                return false
            }

            if (parseInt(userRole.level, 10) >= 8) {
                return true
            }

            const nRoles = config && Array.isArray(config.nRoles) ? config.nRoles : null
            if (!nRoles || nRoles.length === 0) {
                return false
            }

            return nRoles.some((role) => {
                const matchesRole = role.roleId == this.user.rol || role.roleId == userRole.id
                return matchesRole && role.permissions && role.permissions.includes('m')
            })
        },

        canAccessOpenedAudit(audit, authorId, employee, employeeRolLevel, templateLevel) {
            const isAuthor = authorId && employee && employee.id == authorId
            if (isAuthor || employeeRolLevel == 8 || this.checkReadPermissions(this.detailId)) {
                return true
            }

            const meetsTemplateLevel = employeeRolLevel >= templateLevel
            if (meetsTemplateLevel && audit.complete_date) {
                return true
            }

            // Reopen clears complete_date. Gestión (m) keeps the level-based access that opened the completed audit.
            const template = this.$store.getters['audit/getTemplateById'](this.detailId)
            return meetsTemplateLevel && (this.checkManagePermission(audit && audit.config) || this.checkManagePermission(template && template.config))
        },

        onAuditReopened() {
            this.openAddedit(this.addeditId)
        },

        checkReadPermissions(id) {
            // Validar que el usuario existe
            if (!this.user || !this.user.rol) {
                return false
            }

            const template = this.$store.getters['audit/getTemplateById'](id)
            const userRole = this.$store.getters['employee/getRol'](this.user.rol)

            // Validar que el rol existe
            if (!userRole) {
                return false
            }

            if (userRole.level >= 8) {
                return true
            }

            // Si el objeto config no existe o no tiene nRoles/roles, permitir visualización (comportamiento por defecto)
            if (!template || !template.config || (!template.config.nRoles && !template.config.roles)) {
                return true
            }

            // Si existe config.nRoles, verificar permisos de lectura según roles
            if (template.config.nRoles && template.config.nRoles.length > 0) {
                return template.config.nRoles.some((role) => {
                    return role.roleId == userRole.id && role.permissions && role.permissions.includes('r')
                })
            }

            // Si existe config.roles (formato antiguo), mantener compatibilidad - permitir visualización
            if (template.config.roles && template.config.roles.length > 0) {
                // Si el usuario tiene nivel 8 o superior, tiene todos los permisos
                if (userRole.level >= 8) {
                    return true
                }
                return template.config.roles.includes(this.user.rol)
            }

            return false
        },

        loadAuditEdit(id) {
            if (typeof id === 'undefined' || id === 'add') {
                var templateID = this.$route.params.id
                if (!this.checkPermissions(templateID, true)) {
                    this.$overlay.hide()
                    this.$popup.alert({
                        message: this.$t('answer.timing.not_has_role_permission', {
                            name: this.user ? this.user.name : '',
                            roles: this.rolesWithWritePermissions()
                        })
                    })

                    return
                }
                this.createAudit(templateID)
            } else {
                this.addeditId = id

                this.openAddedit(id)

                this.$router.push({
                    name: 'AuditEdit',
                    params: { id: this.detailId, edit: this.addeditId }
                })
            }
        },
        async openAddedit(id) {
            var self = this
            // self.$bar.reset();
            if ((id == self.addeditId && typeof id !== 'undefined' && id != 'add') || (typeof self.addeditId !== 'undefined' && self.addeditId != 'add')) {
                await new Promise((resolve) =>
                    setTimeout(() => {
                        self.$bar.reset()
                        resolve()
                    }, 300)
                )

                self.$bar.addAction('back', {
                    callback: function () {
                        self.showErrors = false
                        self.openSection = null
                        self.$router.push({
                            name: 'AuditDetail',
                            params: { id: self.detailId }
                        })
                    },
                    label: self.$t('menu_aux.action.back')
                })

                let audit = self.$store.getters['audit/getById'](id)
                let empl = audit.employee_ref.id
                let empl_curr = self.$store.getters['loginUser/getLocalEmployee']
                empl_curr = self.$store.getters['employee/getEmployee'](empl_curr)
                let audit_tmpl = this.$store.getters['audit/getTemplateById'](self.detailId)
                let level = audit_tmpl.config != null && typeof audit_tmpl.config.level !== 'undefined' ? audit_tmpl.config.level : 3
                let employeeRolLevel = self.$store.getters['employee/getRol'](empl_curr.rol).level

                if (this.canAccessOpenedAudit(audit, empl, empl_curr, employeeRolLevel, level)) {
                    // Quitar botón finalizar si el audit no tiene tu rol asignado
                    let template = this.templates[this.$route.params.id]
                    let templateroles = template && template.config && template.config.roles && template.config.roles.lenght > 0 ? template.config.roles : false
                    let includeRol = templateroles && this.user && this.user.rol ? templateroles.includes(this.user.rol) : true

                    if (/*empl === empl_curr.id &&*/ this.templates && Object.values(this.templates).length > 0 && !audit.complete_date && !(audit.state == 'past' && !audit.def.can_edit.inPast) && !(audit.state == 'future' && !audit.def.can_edit.inFuture) && includeRol && this.userAppAccess && audit.status !== 'completed' && this.checkPermissions(this.addeditId)) {
                        self.$bar.addAction('save', {
                            opened: true,
                            label: i18n.t('popup.audits.complete'),
                            callback: function () {
                                self.$popup.confirm({
                                    message: self.$t('popup.audits.confirm_save'),
                                    textSave: self.$t('popup.audits.save'),
                                    callSave: function () {
                                        var validation = []
                                        var oData = {
                                            cType: self.checkType,
                                            check: self.addeditId,
                                            emp: self.$store.getters['loginUser/getLocalEmployee'],
                                            date: moment().unix(),
                                            values: [],
                                            finalScores: self.template.config.eval
                                        }
                                        let audit = self.$store.getters['audit/getById'](self.addeditId)
                                        // know if the audit has sections
                                        if (audit && Object.values(audit.sections).length > 0) {
                                            // validation to close an audit with all mandatory fields completed
                                            let incompleteItemFound = false
                                            self.openSection = true

                                            Object.values(audit.sections).forEach((items) => {
                                                Object.values(items.items).forEach(function (item) {
                                                    if (item.mandatory && item.is_visible && ((!item.value && item.value !== 0) || item.value == null) && !self.itemsExcluded.includes(parseInt(item.type))) {
                                                        validation.push(false)

                                                        self.showErrors = true
                                                        if (!item.complete_date && !incompleteItemFound) {
                                                            setTimeout(() => {
                                                                let element = document.getElementById(item.item_id)

                                                                if (element) {
                                                                    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
                                                                } else {
                                                                    console.error('Element not found:', item.item_id)
                                                                }
                                                            }, 0)

                                                            incompleteItemFound = true
                                                        }

                                                        return self.$snackbar.error({
                                                            message: self.$t('audit.save_error_uncomplete')
                                                        })
                                                    }
                                                })
                                            })
                                        }

                                        if (validation.indexOf(false) == -1) {
                                            oData.values = JSON.stringify(oData.values)
                                            self.$overlay.loading()

                                            self.$store.dispatch('audit/complete', oData).then(function (response) {
                                                self.$store.dispatch('audit/loadTemplates', {}).then(function () {
                                                    self.$overlay.hide()
                                                    if ((self.template.config && self.template.config.show_score == undefined) || (self.template.config && self.template.config.show_score == 1)) {
                                                        self.$router.push({
                                                            name: 'AuditDetail',
                                                            params: { id: self.detailId }
                                                        })
                                                    } else {
                                                        self.$popup.alert({
                                                            message: self.$t('audit.points_total', { name: self.user.name }),
                                                            textSave: self.$t('login.pw_forgot.action'),
                                                            customClass: 'auditPoints',
                                                            data: self.check.score,
                                                            callSave: function () {
                                                                // self.$router.push("/config/printer");
                                                                self.$router.push({
                                                                    name: 'AuditDetail',
                                                                    params: { id: self.detailId }
                                                                })
                                                            }
                                                        })
                                                    }
                                                })
                                            })
                                        }
                                    }
                                })
                            }
                        })
                    }
                } else {
                    self.$popup.alert({
                        closable: false,
                        blocking: false,
                        message: self.$t('popup.audits.not_level_permission'),
                        textSave: self.$t('popup.audits.exit'),
                        callSave: function (response) {
                            self.$router.push({
                                name: 'AuditDetail',
                                params: { id: self.detailId }
                            })
                        }
                    })
                }
            } else {
                var audit_tmpl = this.$store.getters['audit/getTemplateById'](self.detailId)
                var level = audit_tmpl.config != null && typeof audit_tmpl.config.level !== 'undefined' ? audit_tmpl.config.level : 3
                var list = false
                if (id != undefined) {
                    var empl = self.$store.getters['audit/getById'](id).employee_ref.id
                    if (empl && empl != null) {
                        empl = self.$store.getters['employee/getEmployee'](empl)
                    }
                    list = empl ? [empl] : self.$store.getters['employee/getAccessUsers'](level)
                } else {
                    list = self.$store.getters['employee/getAccessUsers'](level)
                }

                self.$popup.access({
                    list: list,
                    callAfterAccess: function (response) {
                        if (response) {
                            if (response.status) {
                                self.$popup.close()
                                self.$bar.reset()

                                self.$store.dispatch('audit/changeSupervisor', { emp_id: response.emp_id })

                                if (id && typeof id !== 'undefined' && id != 'add') {
                                    self.addeditId = id

                                    self.$router.push({
                                        name: 'AuditEdit',
                                        params: { id: self.detailId, edit: self.addeditId }
                                    })
                                } else {
                                    self.$store
                                        .dispatch('audit/add', {
                                            tpl_id: self.detailId,
                                            cType: self.checkType,
                                            emp_ref: response.emp_id
                                        })
                                        .then(function (response) {
                                            self.addeditId = response.id

                                            self.$router.push({
                                                name: 'AuditEdit',
                                                params: { id: self.detailId, edit: self.addeditId }
                                            })
                                        })
                                }
                            }
                        }
                    }
                })
            }
        },

        listAudits() {
            var self = this

            var empl_curr = self.$store.getters['loginUser/getLocalEmployee']
            empl_curr = self.$store.getters['employee/getEmployee'](empl_curr)

            this.$popup.listAudits({
                list: this.templates,
                level: parseInt(self.$store.getters['employee/getRol'](empl_curr.rol).level),
                callback: function (self2, store) {
                    self2.$popup.close()
                    self.createAudit(self2.selected)
                }
            })
        }
    },
    created() {
        this.load()
    },
    watch: {
        $route(to, from) {
            // Skip reload when the template and checklist ids stay the same.
            // Why: in maybeScrollToNonConformityFromActionPlan, after returning from an Action Plan,
            // detail.vue consumes query.fromActionPlanChecklist and nonConformityId with router.replace (changes $route query only).
            // load() would refetch the audit, show the overlay, and can remount the checklist (including the "next pending section" scroll).
            if (from && to.params.id === from.params.id && to.params.edit === from.params.edit) {
                return
            }
            this.load()
        },
        audit(newVal, oldVal) {
            if (this.auditsWithTempId.length > 0 && this.$route.params.edit) {
                const routerEdit = this.$route.params.edit
                this.auditsWithTempId.forEach((audit) => {
                    if (audit.temporal_id == routerEdit) {
                        this.addeditId = audit.id
                        this.$router.push({
                            name: 'AuditEdit',
                            params: { id: this.detailId, edit: this.addeditId, noRefresh: true }
                        })
                    }
                })
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        next()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#content.audit {
    $column-width: 0%;
    $column-max-width: 0px;
    $content-width: 100%;
    overflow: hidden;

    &.template-list {
        @include display-flex();
        @include flex-direction(column);
        gap: 16px;
        padding: 8px;
        box-sizing: border-box;

        >.content {
            flex: 1 1 auto;
            min-height: 0;
            height: auto !important;
            max-height: none;
            gap: 16px;
            padding: 0 !important;
        }
    }

    >.content {
        $content-margin: 0px;

        @include display-flex();
        @include flex-direction(row);
        @include flex-wrap(wrap);
        @include align-content(flex-start);
        @include justify-content(flex-start);
        @include border-radius($default-border-radius);
        gap: 24px;
        padding-top: 25px;
        box-sizing: border-box;
        background-color: $default-bg-color;
        margin: $content-margin 0 0 0;
        width: calc(#{$content-width}) !important;
        min-width: calc(100% - #{$column-max-width}) !important;
        height: calc(100% - #{$content-margin}) !important;
        max-height: 93%;
        border: none;
        position: relative;

        &.detail-audit {
            max-height: 100%;
        }

        .audit-templates-loader {
            @include display-flex();
            @include align-items(center);
            @include justify-content(center);
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            min-height: 100%;

            .loader {
                @include background($image: img('loader_dark.svg'), $size: 64px, $position: center center);
                width: 80px;
                height: 80px;
            }
        }

        &.empty {
            @include display-flex();
            @include align-items();
            @include justify-content(flex-end);
            padding-top: 75px;

            .message {
                @include display-inline-flex();
                @include align-items();
                @include background($image: img('alexpose_04.svg'), $size: contain, $position: right center);
                width: 100%;
                padding-right: 150px;
                height: 250px;
                max-height: 100%;
            }
        }
    }

    &.landscape {
        >.content {
            max-height: 89%;

            &.detail-audit {
                max-height: 100%;
            }
        }
    }

    &.portrait {
        padding-bottom: 0px;

        >.content {
            height: 100% !important;
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
    }
}

/* Estilos específicos para el SearchBar en Auditorías */
#content.audit.template-list .audit-templates-search-bar {
    width: 100%;

    .search-container {
        width: 100% !important;
        height: 40px !important;
        margin: 0 !important;
        padding: 0 !important;

        .search {
            height: 40px !important;
            padding: 8px 60px 8px 40px !important;
            background-size: 16px !important;
            font-size: 16px !important;

            &::placeholder {
                font-size: 16px !important;
            }
        }
    }
}

// estilos para el search bar de secciones en un checklist de auditorías
#content.audit .audit-content {
    .sections-searchbar-container {
        .search {
            @media (max-width: 1023px) {
                background-size: 18px !important;
            }
        }

        @media (min-width: 1024px) {
            .search {
                font-size: 16px !important;
            }

            .search-container {
                height: 61px !important;

                .search {
                    height: 40px !important;
                    font-size: 18px !important;
                    font-family: $text;
                }

                .search::placeholder {
                    font-size: 18px !important;
                    font-family: $text;
                }
            }
        }
    }
}
</style>
